// BHP-1038: Tailwind dashboard content (reference screen #2). Identity comes
// from the OIDC token instead of the retired Redux userReducer; the chrome is
// provided by SecuredShell (AppShell) at the route level.
import { getCurrentUserFromToken } from '../../features/account/application/accountApi';

export default function Dashboard(): JSX.Element {
  // First name only, consistent with the sidebar "Welcome," block.
  const name = getCurrentUserFromToken()?.firstName ?? '';

  return (
    <div className="rounded-lg border border-black/5 bg-surface p-6 shadow-sm">
      <p className="text-sm text-ink-muted">
        {name !== '' ? `Welcome back, ${name}.` : 'Welcome back.'}
      </p>
    </div>
  );
}
